(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["greate-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('greate-legal-guarantee')) {
    customElements.define('greate-legal-guarantee', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const dialog = this.querySelector('dialog');

        this.querySelector('[data-guarantee-open]').addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
        }, options);

        this.querySelector('[data-guarantee-close]').addEventListener('click', () => dialog.close(), options);

        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.querySelector('dialog')?.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
